import { c as _c } from "react/compiler-runtime";
import { type StandardSvgProps } from "src/components/svg/StandardSvgProps";

//#region [Props]
type LocationCircleSvgProps = {} & StandardSvgProps;
//#endregion

//#region [Component]
export default function LocationCircleSvg(t0) {
  const $ = _c(6);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <radialGradient id="radial-gradient-LocationCircleSvg" cx="0.5" cy="0.5" r="0.5" gradientUnits="objectBoundingBox"><stop offset="0" stopColor="var(--palette-melrose2)" /><stop offset="0.265" stopColor="var(--palette-french-pass)" /><stop offset="0.567" stopColor="var(--palette-your-pink)" /><stop offset="0.764" stopColor="var(--palette-illusion)" /><stop offset="1" stopColor="var(--palette-melrose2)" /></radialGradient>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <defs>{t1}<radialGradient id="radial-gradient-2-LocationCircleSvg" gradientUnits="objectBoundingBox" cy="0.328"><stop offset="0" stopColor="var(--palette-melrose2)" /><stop offset="0.265" stopColor="var(--palette-french-pass)" /><stop offset="0.567" stopColor="var(--palette-your-pink)" /><stop offset="0.764" stopColor="var(--palette-illusion)" /><stop offset="1" stopColor="var(--palette-melrose2)" /></radialGradient></defs>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path className="LocationCircleSvgPath1" d="M17,2A15,15,0,0,0,6.393,27.607,15,15,0,1,0,27.607,6.393,14.9,14.9,0,0,0,17,2m0-2A17,17,0,1,1,0,17,17,17,0,0,1,17,0Z" transform="translate(1280 397)" fill="url(#radial-gradient-LocationCircleSvg)" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <g transform="translate(-1280 -397)">{t3}<g transform="translate(1292 406)"><path className="LocationCircleSvgPath2" d="M271.239,1020.964c-1.095,2.133-4.331,7.056-4.468,7.263a.427.427,0,0,1-.706,0c-.131-.209-3.379-5.125-4.468-7.266a5.536,5.536,0,0,1-.608-2.69,5.434,5.434,0,0,1,10.868,0A5.556,5.556,0,0,1,271.239,1020.964Zm-4.819-4.653a2,2,0,1,0,2.006,2A2,2,0,0,0,266.42,1016.311Z" transform="translate(-260.986 -1012.84)" fillRule="evenodd" fill="url(#radial-gradient-2-LocationCircleSvg)" /></g></g>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== className) {
    t5 = <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" className={className}>{t2}{t4}</svg>;
    $[4] = className;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}
//#endregion